import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse, IProduct } from '@boma/website/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  getProduct(id: string) {
    return this.httpClient.get<IProduct>(
      `${this.base}api/v${this.version}/Products/${id}`
    );
  }
}
